import React from 'react';
import { InputText } from 'components/inputText/inputText';
import { MAX_PASSPORT_LENGTH } from 'components/shared/InputPassport/constants';
import { getPassportValidations } from 'components/shared/InputPassport/getPassportValidations';
import { getMessageErrors } from 'components/shared/InputPassport/getMessageErrors';

export const InputPassport = ({
    userProfile,
    userProfileForm,
    formActions,
    onValidation,
    label = '',
    placeholder = '',
    isRequired = false,
    disabled = false,
}) => {
    const validations = getPassportValidations(isRequired, userProfile.nationality);
    const messageErrors = getMessageErrors(isRequired);

    return (
        <InputText
            profileModel="userProfile.passport"
            placeholder={placeholder}
            label={label}
            type="text"
            name="passport"
            id="passport"
            maxLength={MAX_PASSPORT_LENGTH.toString()}
            defaultValue={userProfile.passport}
            disabled={disabled}
            validations={validations}
            messagesError={messageErrors}
            isValidated={() => onValidation?.(true)}
            isNotValidated={() => onValidation?.(false)}
            userProfileForm={userProfileForm}
            userProfile={userProfile}
            formActions={formActions}
        />
    );
};
